<template>
  <div>
    <base-field addon-left-icon="pound-sign" addon-right="sqm" label="Total Floor Area (sqm)">
      <base-input v-model="value.totalFloorArea" numeric readonly />
    </base-field>
    <base-field addon-left-icon="pound-sign" label="Build Price per sq m">
      <base-input v-model="value.financials.buildPricePerSqm" numeric readonly />
    </base-field>
    <base-field addon-left-icon="pound-sign" label="Project Price per sq m">
      <base-input v-model="value.financials.projectPricePerSqm" numeric readonly />
    </base-field>
    <base-field addon-left-icon="pound-sign" label="Profit">
      <base-input v-model="value.financials.profit" numeric readonly />
    </base-field>
    <base-field addon-right-icon="percent" label="Profit Margin (GDV)">
      <base-input v-model="value.financials.profitMarginGdv" numeric readonly />
    </base-field>
    <base-field addon-right-icon="percent" label="Profit Margin (Costs)">
      <base-input v-model="value.financials.profitMarginCosts" numeric readonly />
    </base-field>
  </div>
</template>

<script>
import { ProjectCalculations } from '@/libs'

export default {
  created () {
    this.calculate()
  },

  name: 'ProjectCalculatedFinancials',

  props: {
    value: { required: true, type: Object }
  },

  methods: {
    calculate () {
      const calculate = new ProjectCalculations(this.value)

      this.value.financials.buildPricePerSqm = calculate.getBuildCostPerSqm()
      this.value.financials.profit = calculate.getTotalProfit()
      this.value.financials.profitMarginCosts = calculate.getProfitMarginCost()
      this.value.financials.profitMarginGdv = calculate.getProfitMarginGdv()
      this.value.financials.projectPricePerSqm = calculate.getProjectCostPerSqm()
    }
  },

  watch: {
    value: {
      deep: true,
      handler () {
        this.calculate()
      }
    }
  }
}
</script>
